import Layout4Login from "components/layout/Layout4Login";
import Css from './Login.module.css';
import { Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ApiConection from "api_ref/ApiConection";

export default function ForgotPasswordConfirm() {
    const navigate = useNavigate();

    const api = new ApiConection();
    const [validated, setValidated] = useState(false);
    const [input, setInput] = useState({
        email: ''
    });
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (event) => {
        const { name, type, value } = event.target;

        setInput(prevData => {
            return { ...prevData, [name]: value }
        })
    }

    const handleLogin =  () => {
        navigate('/');
    }


    return (
        <Layout4Login>
             <div className={Css.Login_outer_layout1}>
                <div className={Css.admin}>
                    <div className='d-flex flex-row'>
                        <div className=''>
                            <img src={require("images/mst.jpg")} className={Css.imgsize} />
                        </div>
                        <div className='p-5 m-2'>
                            <Form noValidate validated={validated} onSubmit={handleLogin}  style={{width:'330px'}}>
                                <img src={require("images/DCasS.png")} height={69} />
                                <h3 className={`mt-2`}>กรุณาตรวจสอบอีเมล</h3>
                                <label className={Css.font2}>ยินดีต้อนรับสู่ระบบจัดการหลังบ้านของเรา!!</label>
                                <Form.Group as={Row} className={`text-start mb-2 mt-5 ${Css.font1}`}>
                                    <Form.Label >ระบบได้ส่ง ลิงก์ สำหรับ รีเซ็ตรหัสผ่าน ทางอีเมลแล้ว.</Form.Label>
                                </Form.Group>
                             
                                {
                                    alert !== '' &&
                                    <div className="alert alert-danger" role="alert">
                                        <div className="text-end">
                                            <button type="button" className="btn-close" onClick={(event) => setAlert('')}></button>
                                        </div>

                                        {alert}
                                    </div>
                                }
                                <div className={`mt-4`}>
                                    <Button type={'submit'} className={`${Css.loginbtn} w-100 mt-3`} >
                                        {
                                            loading === true &&
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        }
                                        เข้าสู่ระบบ
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </Layout4Login>
    )
}